import type {
  AcceptInvitationResponse,
  CheckDomainResponse,
  CheckOrgMembersResponse,
  ValidateInvitationResponse,
} from '@/shared/domain/types/auth.types';

import api from './axios.service';

export const authApi = {
  async checkDomain(email: string): Promise<CheckDomainResponse> {
    const response = await api.get('/auth/check-domain', {
      params: { email },
    });
    return response.data;
  },

  async checkOrgMembers(orgId: string): Promise<CheckOrgMembersResponse> {
    const response = await api.get('/auth/check-org-members', {
      params: { orgId },
    });
    return response.data;
  },

  async validateInvitation(token: string): Promise<ValidateInvitationResponse> {
    const response = await api.get('/auth/validate-invitation', {
      params: { token },
    });
    return response.data;
  },

  async acceptInvitation(token: string, userId: string): Promise<AcceptInvitationResponse> {
    const response = await api.post('/auth/accept-invitation', {
      token,
      userId,
    });
    return response.data;
  },
};
